/* eslint-disable */
import React, { useContext, useEffect, useMemo, useState } from "react";

// import { AppStackParamList, RootStackParamList } from "../../types";

import { useHistory, useParams } from "react-router-dom";
import { Button, Grid, Paper, TextField } from "@material-ui/core";
import {
  alertStyle,
  backgroundStyle,
  btnStyle,
  checkListStyle,
  h3Style,
  inputStyle,
  logoStyle,
  paperStyle,
  pStyle,
} from "./styles";
import { AuthContext } from "../../contexts/authContext";
import { useValidPasswordAdvance } from "../../hooks/useValidPasswordAdvance";
import { useValidCode } from "../../hooks/useValidCode";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Alert,
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { PasswordType } from "interfaces/IPassType";
import { Header } from "components/Header/Header";

const CheckPassword: React.FC<any> = () => {
  /* States and context declaration */
  const { passwordAdvance, setPasswordAdvance, passwordAdvanceIsValid } =
    useValidPasswordAdvance(null);
  const [confirmPass, setConfirmPass] = useState("");
  const [confirmPassError, setConfirmPassError] = useState("");
  const [showPassword, setshowPassword] = useState<boolean>(false);
  const [showCPassword, setshowCPassword] = useState<boolean>(false);
  const { code, setCode } = useValidCode(null);
  const authContext = useContext(AuthContext);
  const { email, oldPassword, type }: any = useParams();
  const [genericErrorMessage, setGenericErrorMessage] = useState("");
  const history = useHistory();
  
  useEffect(() => {
    onComparePassword(confirmPass);
  }, [confirmPass, passwordAdvance]);

  const onComparePassword = (confirmPass: string) => {
    setConfirmPass(confirmPass);
    if (confirmPass == "") {
      setConfirmPassError("");
      return;
    }
    if (confirmPass !== passwordAdvance) {
      setConfirmPassError(
        "The passwords you have entered don’t match, please correct to proceed"
      );
    } else {
      setConfirmPassError("Passwords match");
    }
  };

  const onchangePassword = async (e: any) => {
    e.stopPropagation();
    if (type == PasswordType.RECOVERY) {
      try {
        await authContext.forgotPassword((email as string).toLowerCase(), code, passwordAdvance);
        history.push("/SignIn");
      } catch (error: any) {
        setGenericErrorMessage(`An error ocurred: ${error.message}`);
      }
    } else {
      try {
        await authContext.completeNewPassword(
          (email as string).toLowerCase(),
          oldPassword,
          passwordAdvance
        );
        // history.push(`${AuthPAGES.changePhone}/${email}`);
        history.push("/");
        // UNCOMMENT WHEN CORS ISSUE RESOLVED"
        // await authContext.signInOTPNotRedirec(email, passwordAdvance);
        // await authContext.signInWithEmailnoRedirect(email, passwordAdvance, signInCallback);
        // if (phone) {
        //   try {
        //     const processPhone = phone.replace("|", "").replace(/\s/g, "");
        //     console.log(processPhone);

        //     history.push(`${AuthPAGES.verifyPhone}/${phone}/${email}`);
        //     await authContext.onChangePhoneSubmitted(processPhone, email);

        //   } catch (e:any) {
        //     setGenericErrorMessage(e.message);
        //     console.log(e);
        //   }
        // }
      } catch (error: any) {
        setGenericErrorMessage(`${error.message}`);
        console.log(error);
      }
    }
  };

  const handleClickShowPassword = () => {
    setshowPassword(!showPassword);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleClickShowCPassword = () => {
    setshowCPassword(!showCPassword);
  };

  const handleMouseDownCPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <>
      <Header showSettings={false} />
      <div style={backgroundStyle}>
        <Grid container justifyContent="center" alignContent="center">
          <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
            <Paper elevation={0} style={paperStyle}>
              <div style={{ margin: "0px auto" }}>
                <Grid style={logoStyle}>
                  <h3 style={h3Style}>Set Your Password</h3>
                </Grid>
                {genericErrorMessage != "" ? (
                  <Alert style={alertStyle} variant="outlined" severity="error">
                    Error: {genericErrorMessage}
                  </Alert>
                ) : null}
                <Grid style={checkListStyle}>
                  {passwordAdvanceIsValid
                    ? passwordAdvanceIsValid.map((item: any, index: number) => {
                        if (item.text)
                          return (
                            <p style={pStyle} key={index}>
                              {item.active ? (
                                <CheckCircleIcon
                                  style={{ color: "green", width: "18px" }}
                                />
                              ) : (
                                <CheckCircleOutlineIcon
                                  style={{ width: "18px" }}
                                />
                              )}
                              {item.text}
                            </p>
                          );
                      })
                    : null}
                </Grid>
                {type == PasswordType.RECOVERY && (
                  <FormControl fullWidth variant="outlined">
                    <OutlinedInput
                      style={{ ...inputStyle, marginTop: "0px" }}
                      type="text"
                      value={code}
                      onChange={(e: any) => setCode(e.target.value)}
                      placeholder="Enter Confirmation Code"
                    />
                  </FormControl>
                ) 
                // : 
                // (
                //   <FormControl fullWidth variant="outlined">
                //     <OutlinedInput
                //       error={genericErrorMessage != ""}
                //       size="small"
                //       style={{ ...inputStyle, marginTop: "0" }}
                //       type="text"
                //       value={phone}
                //       onChange={(e: any) => setPhone(e.target.value)}
                //       placeholder="Phone Number"
                //     />
                //   </FormControl>
                // )
                }
                <FormControl fullWidth variant="outlined">
                  <OutlinedInput
                    style={{
                      ...inputStyle,
                      marginTop:"12px"
                    }}
                    type={showPassword ? "text" : "password"}
                    value={passwordAdvance}
                    onChange={(e: any) => setPasswordAdvance(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    placeholder="Set New Password"
                  />
                </FormControl>
                <FormControl fullWidth variant="outlined">
                  <OutlinedInput
                    style={inputStyle}
                    type={showCPassword ? "text" : "password"}
                    value={confirmPass}
                    onChange={(e: any) => setConfirmPass(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowCPassword}
                          onMouseDown={handleMouseDownCPassword}
                          edge="end"
                        >
                          {showCPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    placeholder="Confirm New Password"
                  />
                </FormControl>
              </div>
            </Paper>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              style={btnStyle}
              fullWidth
              onClick={(e) => {
                onchangePassword(e);
              }}
              disabled={
                passwordAdvanceIsValid[0].text === "Password Strength: Good" &&
                confirmPassError === "Passwords match"
                  ? false
                  : true
              }
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default CheckPassword;
